import { Button, Form, Input, Select } from 'antd';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';

const statusOptions = [
  { value: 1001, label: 'Draft' },
  { value: 1002, label: 'Published' },
];

const typeOptions = [
  { value: 1001, label: 'Premium ETF' },
];

const ItemForm = ({ form, submiting, onFinish, initialValues, name }) => (
  <Form
    {...formItemLayout}
    form={form}
    name={name || 'form'}
    onFinish={onFinish}
    initialValues={initialValues}
    scrollToFirstError
  >
    <Form.Item name="title" label="Title" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item
      name="slug"
      label="Slug"
      rules={[{ required: true }]}
      extra="Machine-readable plan identifier, e.g. pro, premium"
    >
      <Input />
    </Form.Item>

    <Form.Item name="type" label="Type" rules={[{ required: true }]}>
      <Select>
        {typeOptions.map(opt => (
          <Select.Option key={opt.value} value={opt.value}>
            {opt.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item name="status" label="Status" rules={[{ required: true }]}>
      <Select>
        {statusOptions.map(opt => (
          <Select.Option key={opt.value} value={opt.value}>
            {opt.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item name="excerpt" label="Excerpt">
      <Input.TextArea rows={2} />
    </Form.Item>

    <Form.Item name="description" label="Description">
      <Input.TextArea rows={5} />
    </Form.Item>

    <Form.Item {...tailFormItemLayout}>
      <Button type="primary" htmlType="submit" loading={submiting}>
        Save
      </Button>
    </Form.Item>
  </Form>
);

export default ItemForm;
